module.exports = __webpack_public_path__ + "arrow-right.png?e7afcf02b4939c9d7588b0e5dbf61a61";